






















































import Vue from "vue";
import CustomType from "../../src/types/vue";

export interface ComponentApp extends Vue {}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: "Body",
  props: {},
  data() {
    return {};
  },
  methods: {},
  components: {},
  computed: {
    locale: function() {
      return this.$store.state.locale;
    }
  },
  mounted: function() {
    $(window).scroll(function() {
      $(".scrollListner").each(function() {
        var imagePos = $(this).offset()!.top;
        var decale = Number($(this).attr("data-scrollPos"));
        var lauchOdometer = Number($(this).data("odometer"));

        if (isNaN(decale)) decale = 900;

        var topOfWindow = $(window).scrollTop()!;
        if (imagePos < topOfWindow + decale) {
          if (!isNaN(lauchOdometer)) $(this).html(lauchOdometer.toString());

          $(this).addClass("scrollIncome");
        }
      });
    });
  }
};

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/modules/Body.vue